import React from 'react';
import moment from 'moment';
import './Document.css';

const Document = ({ businessName, selectedTerritory, selectedState }) => {
  return (
    <div id='previewDocTop'>
      <div className='mb-3 mt-2 d-flex flex-wrap justify-content-end'>
        Date: {moment(new Date()).format('MM/D/YYYY')}
      </div>
      <div className='text-left'>
        <div>To,</div>
        <div className='mb-3'>
          Agrocel Industries Pvt Ltd
          <br />
          184, B- 701/702, Flexcel Park,
          <br />
          87, SV Rd, Jogeshwari West
          <br />
          Mumbai – 400102
        </div>
        <div className='mb-3'>
          SUB: Business commitment for the Dealer/Distributorship
        </div>
        <div className='mb-2'>
          Respected Sir,
          <br />I would like to associate with you in the capacity of Dealer for
          the {selectedTerritory ? selectedTerritory : ''}&nbsp; territory. My
          Dealer/Distributorship details are as follows:
        </div>
        <div className='mb-2'>
          Dealership Name :{' '}
          {businessName && businessName.business_name
            ? businessName.business_name
            : ''}
        </div>
        {businessName.application_creation_date && (
          <div className='mb-2'>
            Application Date : {businessName.application_creation_date}
          </div>
        )}
        <div className='mb-4'>
          Address:
          {businessName && businessName.address ? businessName.address : ''}
          <br />
          Territory: {selectedTerritory ? selectedTerritory : ''},
          {selectedState ? selectedState : ''}
          <br />
          Here is my business commitment to you for the next 3 years.
        </div>
      </div>
    </div>
  );
};

export default React.memo(Document);
